import { lazy, Suspense, useState } from "react";
import { Outlet, useLocation } from "react-router";
import { CommandPalette } from "../features/palette/CommandPalette";
import { useEnterDueScheduledOnOpen } from "../features/scheduled/useEnterDueScheduledOnOpen";
import { AccountSheetContext } from "./accountSheetContext";
import { Rail } from "./Rail";
import { Sidebar } from "./Sidebar";
import { TabBar } from "./TabBar";
import { useLayoutMode } from "./useLayoutMode";
import { useMe } from "./me";

// Mounted on first open: the sheet library is not needed to start the app.
const AccountSheet = lazy(async () => ({ default: (await import("./AccountSheet")).AccountSheet }));

export function AppShell() {
  const mode = useLayoutMode();
  const [sheet, setSheet] = useState(false);
  const [sheetUsed, setSheetUsed] = useState(false);
  // Any REST call extends the session cookie; this one runs on every app open.
  useMe();
  const { pathname } = useLocation();
  const fullScreen = pathname === "/add";
  useEnterDueScheduledOnOpen();

  const phone = mode === "phone";
  // One tree for every width, so crossing a breakpoint never remounts the page (and its state).
  return (
    <AccountSheetContext.Provider
      value={() => {
        setSheetUsed(true);
        setSheet(true);
      }}
    >
      <div className={phone ? "safe-top min-h-dvh pb-28" : "flex min-h-dvh"}>
        {mode === "desktop" && <Sidebar />}
        {mode === "touch" && <Rail />}
        {!phone && <CommandPalette />}
        <main className={phone ? undefined : "min-w-0 flex-1"}>
          <Outlet />
        </main>
      </div>
      {phone && !fullScreen && <TabBar />}
      {sheetUsed && (
        <Suspense fallback={null}>
          <AccountSheet open={sheet} onOpenChange={setSheet} />
        </Suspense>
      )}
    </AccountSheetContext.Provider>
  );
}
